import React from 'react'
import { GridCellParams, GridColumnHeaderParams, GridColumns } from '@material-ui/data-grid'
import Table from '../../../../control/table/table'
import { makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import { ReturnPagingAndSortType } from '../../../../control/table/tableType'
import VirtualizedList from '../../../../control/virtualizedList/virtualizedList'
// import VirtualizedList from '../../../../control/virtualizedList/virtualizedList2'
import Grid from '@material-ui/core/Grid'
// import { mockData } from './mockData'
// import ScrollBar from '../Containers/ScrollBar';
import ListItem from '@material-ui/core/ListItem'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import InfoIcon from '@material-ui/icons/Info'
import EditIcon from '@material-ui/icons/Edit'
import LinearProgress from '@material-ui/core/LinearProgress'
import useWebService from '../../../../services/web/useWebService'
import useLoading from '../../../../control/loading/useLoading'
import * as searchTypes from '../../manageProject/search/searchType'
import useAuthenStore from '../../../../stores/authen/authenStore'

const columns: GridColumns = [
    { field: 'id', headerName: 'ID', width: 200 },
    { field: 'name', headerName: 'fullName', width: 400 },
    { field: 'email', headerName: 'email', width: 400 },
    {
        field: 'teamID',
        headerName: 'teamID',
        type: 'number',
        width: 90,
    },
    {
        field: 'teamName',
        headerName: 'teamName',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        flex: 1,
        // valueGetter: (params: any) => `${params.getValue('firstName') || ''} ${params.getValue('lastName') || ''}`,
    },
    {
        field: 'button',
        sortable: false,
        filterable: false,
        align: 'center',
        width: 200,
        disableClickEventBubbling: true,
        renderCell: (params: GridCellParams) => {
            return (
                <div>
                    <IconButton aria-label="edit" onClick={() => {}}>
                        <EditIcon />
                    </IconButton>
                    <IconButton aria-label="delete">
                        <DeleteIcon />
                    </IconButton>
                </div>
            )
        },
        renderHeader: (params: GridColumnHeaderParams) => <div></div>,
    },
]

const rows = [
    {
        id: '228',
        name: 'สงกรณ์ เสียงสืบชาติ (พี่ไก่)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'songkorn.s@cdg.co.th',
        department: 'GM',
    },
    {
        id: 'O00001',
        name: 'รุจิภา  บุญจุบัน (โอ)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'roochipa.b@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00002',
        name: 'ศุภกร อังอำนวยศิริ (บอย)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'supakorn.a@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00005',
        name: 'ปวริศ  โกวิทวีรธรรม (เต้)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'pawarit.k@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00009',
        name: 'อนวัช ชัยศักดิ์ (แชมป์)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'anawach.c@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00010',
        name: 'วรมินทร์ สัตยาธาร (มิน)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'woramin.s@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00012',
        name: 'ธนะวัฒน์ ปิ่นรัตน์  (ฟลอย)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'thanawat.p@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00016',
        name: 'เบญจมาศ กันพรรค์ (ปู)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'benjamart.k@geotalent.co.th',
        department: 'HRD',
    },
    {
        id: 'O00017',
        name: 'กิตติคุณ เอกเอี่ยมพันธุ์ (มอส)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'kittikun.e@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00022',
        name: 'ศิริวัฒน์ แสงบัลลังค์ (บอม)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'siriwat.s@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00025',
        name: 'เฉลิมพล  วิรัชชัย (เบิร์ด)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'chalermpol.v@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00028',
        name: 'สุรสิทธิ  พูนสวัสดิ์ (เก็ต)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'surasit.p@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00030',
        name: 'ถิรวัฒน์  จักษ์ตรีมงคล (โจ)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'tirawat.j@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00035',
        name: 'สริมน  ธีรรัตน์บงกช (แพร)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'sarimon.t@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00036',
        name: 'เอกราช ประสงค์ทรัพย์ (เอก)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'ekkarat.p@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00038',
        name: 'สัณหณัฐ  งามฉายวงศ์ (บิ๊ก)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'sanhanat.n@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00043',
        name: 'เพ็ญพิชชา  พัฒนจิตรศิลป์ (เฟิร์น)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'phenphitcha.p@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00044',
        name: 'ภานุ แถวไธสง (นุ)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'panu.t@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00049',
        name: 'รัตนทัต  พลูวังกาญจน์ (ณัฐ)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'rattanatut.p@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00050',
        name: 'บุลากร  สะสันเทียะ (เอ็ม)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'bulagorn.s@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00051',
        name: 'สุริยา  วงค์คะสุ่ม (โจ้)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'suriya.w@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00052',
        name: 'ศิวะรักษ์  ดีแก้ว (เล็ก)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'siwarak.d@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00054',
        name: 'อานนท์  แฮวอู (บอย)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'anon.h@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00055',
        name: 'ชัยวัฒน์  บ้านเนิน (ชิน)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'chaiwat.b@geotalent.co.th',
        department: 'HRD',
    },
    {
        id: 'O00056',
        name: 'ชานนท์  จันทรมาตย์ (นนท์)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'chanon.cha@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00059',
        name: 'รสริน สุขสมบัติ (ก้อย)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'rossarin.s@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00060',
        name: 'อาจหาญ เสนฤทธิ์ (กั๊ก)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'artharn.s@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00061',
        name: 'โกศล ท่วงที (โจ้)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'koson.t@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00066',
        name: 'ธัญญทิพย์  อภินันทน์ (อ้อ)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'thunyatip.a@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00068',
        name: 'มัลลิกา  โสภา (ปุ๋ย)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'mallika.s@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00074',
        name: 'ณัฐกานต์ พัฒนโพธิ์ (พีท)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'nutthakan.p@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00076',
        name: 'ณัฐสุภา จำรัส (แปม)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'nutsupha.c@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00077',
        name: 'กมลชนก เลิศเรืองรอง  (พลอยลี่)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'kamonchanok.l@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00078',
        name: 'เกียรติมังกร  ศรีขจร (มังกร)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'kiatmangkorn.s@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00080',
        name: 'ชัยธวัช  หงษ์บุญ (จั๊ม)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'chaitawat.h@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00082',
        name: 'สมศักดิ์  แก้วอรสาร (เจ)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'somsak.k@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00083',
        name: 'ศรุต  เบญจรัฐเดช (พี)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'sarut.b@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00084',
        name: 'รภัทร เบญญากุลนันท์ (ป่าน)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'rapat.b@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00085',
        name: 'สมชาย คงทรัพย์ (ชาย)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'somchai.kh@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00086',
        name: 'ชลิดา แก้วเมธากุล (ไอซ์)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'chalida.k@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00087',
        name: 'ศศิวรรณ  ฉ่ำชาวนา (ชมพู่)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'sasiwan.c@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00088',
        name: 'จิราภรณ์ ฟูใจ (แพรว)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'jiraporn.f@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00089',
        name: 'จีรพัฒน์ ศรีพุ่มเงิน (บอส)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'jeerapat.s@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00091',
        name: 'วิธวินท์ กุลธรรมโยธิน (อ้ำ)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'wittawin.k@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00092',
        name: 'วาสิตา เล็กใบ (ป่าน)',
        teamID: '2',
        teamName: 'สีส้ม',
        colorCode: '#f70',
        email: 'wasita.l@geotalent.co.th',
        department: 'WMD',
    },
    {
        id: 'O00093',
        name: 'ณัฐดนัย ไชยกาล (แชมป์)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'natdanai.c@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00094',
        name: 'พรภัทร์ สันติบุปผากุล (พัตเตอร์)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'pornpat.s@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00095',
        name: 'ภิธาภรณ์ ภิระบรรณ์ (แก้ม)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'phithaporn.p@geotalent.co.th',
        department: 'DMD',
    },
    {
        id: 'O00096',
        name: 'ศรวณีย์ พรเจริญ (ลูกศร)',
        teamID: '1',
        teamName: 'สีดำ',
        colorCode: '#000',
        email: 'sornvanee.p@geotalent.co.th',
        department: 'WMD',
    },
]

function createRecord(count: number = 5) {
    let records = []

    for (let i = 0; i < count; i++) {
        records.push({
            field1: `name_${i}`,
            field2: 'https://40thptt.pttplc.com/Storage/Uploads/Milestone/milestone-40th.png?width=201&height=132&mode=pad&scale=both&format=png',
            field3: 'กรุงเทพ',
            field4: 'สาธร',
            field5: '13 กม.',
            field6: 'นาย ธีรวัฒน์',
            field7: 'PTT-00056',
            field8: 'WMD',
            field9: 'Web-Programer',
            field10: '0820648361',
        })
    }
    return records
}

const TableExamView = (props: any) => {
    const { onClickEdit } = props
    const rowPerpage = 10
    const currentPage = React.useRef(1)
    const [mockData, setMockData] = React.useState(createRecord(rowPerpage))
    const callWebService = useWebService()
    const { configLoading, loadingClose, loadingOpen } = useLoading()
    const [isSumItem, setIsSumItem] = React.useState<number>(0)
    const [listItem, setListItem] = React.useState<searchTypes.TReturnList[]>([])
    const authenStore = useAuthenStore()

    React.useEffect(() => {
        const params = {
            userId: 1,
            pageNumber: 1, //param && param?.pageNumber ? param?.pageNumber : 1,
            rowsPerPage: 10,
        }
        getListTbl(params)
    }, [])
    const getListTbl = async (param: searchTypes.ListRequestType) => {
        loadingOpen()
        const res = await callWebService.searchTbl(param, `${authenStore.profile.userGroupId}`)

        const list = res.result.items.map((item, index) => {
            return {
                id: index,
                ...item,
            }
        })
        setIsSumItem(res.result.totalRecords)

        setListItem(list)
        loadingClose()
    }

    const rowRenderer = (props: any) => {
        const {
            key, // Unique key within array of rows
            index, // Index of row within collection
            style, // Style object to be applied to row (to position it)
            parent,
        } = props
        // let selected = (selectedIndex === index);
        // if(listResult && listResult.length === 1){
        //     selected = true;
        // }
        return (
            //         <CellMeasurer
            //         key={key}
            //         // cache={cache.current}
            //         parent={parent}
            //         columnIndex={0}
            //         rowIndex={index}
            //   >

            <div key={key} style={style}>
                <ListItem style={{ borderBottom: 'solid 1px #d9d1d1' }}>
                    <Grid container>
                        <Grid item xs={2}>
                            {/* //onClick={handleClickList(mockData[index])}> */}
                            <IconButton aria-label="InfoIcon">
                                <EditIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container style={{ height: '100%' }}>
                                <Grid item xs={11} style={{ height: '50%', lineHeight: '45px' }}>
                                    <label>ชื่อ: </label>
                                    <label>{listItem[index]?.projectCode}</label>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </ListItem>
                {/* <Divider /> */}
            </div>
            // </CellMeasurer>
        )
    }
    const handleScrollEnd = (rowPerpage: number) => {
        // setMockData(createRecord(rowPerpage))
        const param = {} //formatParams.current

        const params = {
            // userId:
            //     profileStore && profileStore.profile && profileStore.profile.userId
            //         ? profileStore.profile.userId
            //         : undefined,
            userId: 1,
            pageNumber: 1, //param && param?.pageNumber ? param?.pageNumber : 1,
            rowsPerPage: rowPerpage,
            // keywordSearch: param && param.keywordSearch ? param.keywordSearch : undefined,
            // projectStatusId: param && param.projectStatusId ? param.projectStatusId : undefined,
            // projectSubmitTypeId: param && param.projectSubmitTypeId ? param.projectSubmitTypeId : undefined,
            // sortingCol: param && param.sortingCol ? param.sortingCol : undefined,
            // sortingType: param && param.sortingType ? param.sortingType : undefined,
        }
        getListTbl(params)
    }
    return (
        <div style={{ width: '100%', height: '1000px' }}>
            <VirtualizedList rowRenderer={rowRenderer} rowCount={listItem.length} onScrollEnd={handleScrollEnd} />

            {/* <Table
                columns={columns}
                data={rows}
                onClickSort={(params: ReturnPagingAndSortType) => {
                    // console.log('onclickSort', params)
                }}
                onChangePage={(params: ReturnPagingAndSortType) => {
                    // console.log('onChangePage', params)
                }}
                //form service
                pagination={{
                    page: 0,
                    pageCount: 10,
                    pageSize: 10,
                    paginationMode: 'server',
                    rowCount: 100,
                }}
                sortModel={[{ field: 'name', sort: 'asc' }]}
                currentPage={0}
            /> */}
        </div>
    )
}

const TableExam = (props: any) => {
    // const tableEaxamModel = useTableExam()
    return (
        <TableExamView
            {...props}
            // {...tableEaxamModel}
        />
    )
}

export default TableExam
